// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__qgr6A","opacity-transition":"success_opacity-transition__juBQq"};